module.exports = __webpack_public_path__ + "img/truckTrailerRearLeft.0873a17a.svg";